import { Collection } from 'modules/core/lib/mobx-rest'

import PaymentItem from 'modules/payroll_bundle/store/models/PaymentItem'

export class PaymentItems extends Collection<PaymentItem> {
  get cacheKey(): string {
    return 'paymentItems'
  }

  get indexes() {
    return ['payment_id', 'employee_id']
  }

  model() {
    return PaymentItem
  }

  paymentItemsByPaymentIds(paymentIds: number[]): PaymentItem[] {
    return paymentIds.flatMap((paymentId) => {
      return this.filter({ payment_id: paymentId })
    })
  }

  paymentItemByPaymentId(paymentId: number): PaymentItem[] {
    return this.models.filter(
      (paymentItem) => parseInt(paymentItem.attributes.payment_id, 10) === paymentId
    )
  }
}

export default new PaymentItems()
